/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartkeyboardhint2Inputs */

const en_chartkeyboardhint2 = /** @type {(inputs: Chartkeyboardhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the arrow keys to move from bar to bar.`)
};

const de_chartkeyboardhint2 = /** @type {(inputs: Chartkeyboardhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit den Pfeiltasten von Balken zu Balken gehen.`)
};

/**
* | output |
* | --- |
* | "Use the arrow keys to move from bar to bar." |
*
* @param {Chartkeyboardhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartkeyboardhint2 = /** @type {((inputs?: Chartkeyboardhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartkeyboardhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartkeyboardhint2(inputs)
	return de_chartkeyboardhint2(inputs)
});
export { chartkeyboardhint2 as "chartKeyboardHint" }